import { ref, computed } from 'vue'
import { useSignIn } from '@clerk/vue'
import { absoluteAppUrl, authRoutes } from './config'

/**
 * Starts Clerk Google OAuth redirect (Sign-in object only).
 * SSO completion happens on /sso-callback.
 */
export function useGoogleOAuth() {
  const { signIn, isLoaded } = useSignIn()
  const busy = ref(false)
  const error = ref('')

  const ready = computed(() => Boolean(isLoaded.value && signIn.value))

  const start = async () => {
    error.value = ''
    if (!ready.value) {
      error.value = 'Clerk er ikke klar endnu. Prøv igen om et øjeblik.'
      return
    }

    busy.value = true
    try {
      await signIn.value.authenticateWithRedirect({
        strategy: 'oauth_google',
        redirectUrl: absoluteAppUrl(authRoutes.ssoCallback),
        redirectUrlComplete: absoluteAppUrl(authRoutes.home)
      })
    } catch (e) {
      busy.value = false
      error.value = 'Kunne ikke starte Google-login.'
    }
  }

  return { busy, error, ready, start }
}
